import { render } from "./index.vue?vue&type=template&id=e53f1466&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=e53f1466&lang=less&scoped=true"

import exportComponent from "/Users/gejiayang/Desktop/chunlin-overseas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e53f1466"]])

export default __exports__